import { Component, computed, input } from '@angular/core';
import {ElciaIcon, IconType} from '../icon/icon';

@Component({
  selector: 'elcia-title',
  imports: [
    ElciaIcon
  ],
  templateUrl: './title.html',
  styleUrl: './title.scss'
})
export class Title {
  title = input.required<string>();
  subtitle = input<string>();
  iconType = input<IconType>();
  size = input<TitleSize>('4xl');

  sizeClass = computed(() => {
    switch(this.size()) {
      case 'xs': return 'text-xs';
      case 'sm': return 'text-sm';
      case 'base': return 'text-base';
      case 'lg': return 'text-lg';
      case 'xl': return 'text-xl';
      case '2xl': return 'text-2xl';
      case '3xl': return 'text-3xl';
      case '4xl': return 'text-4xl';
      case '5xl': return 'text-5xl';
      case '6xl': return 'text-6xl';
      default: return 'text-4xl';
    }
  });
}

export type TitleSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | undefined;
